// extracted by mini-css-extract-plugin
module.exports = {"trainingAttachmentViewer":"styles_trainingAttachmentViewer__igvv-","main":"styles_main__1Lzzu","docViewer":"styles_docViewer__2eKSq","vidViewer":"styles_vidViewer__2d2mk"};